<template>
  <div>
    <headerNav title="我要升级" />
    <div v-if="applyRecord.id > 0">
      <van-cell-group title="待审核记录">
        <van-cell title="我申请的等级" :value="applyRecord.memberLevelName" />
      </van-cell-group>
      <van-button
        round
        block
        type="info"
        @click="cancelrecord"
        style="width: 300px; margin: 20px auto"
        :color="$abctheme.basecolor"
        >取消申请</van-button
      >
    </div>
    <div v-if="applyRecord.id == 0">
      <van-radio-group v-model="selectLevelId">
        <div class="group-main" v-for="(item, index) in memberlevels" :key="index">
          <div class="group-main-conf">
            <div class="group-main-conf-pic">
              <img :src="abp.setUrl(item.imgPath)" />
            </div>
            <div>品牌:群婴汇</div>
            <div>{{ "级别:" + item.name }}</div>
            <div class="group-main-conf-radio">
              <van-radio
                :checked-color="$abctheme.basecolor"
                :name="item.id"
                :icon-size="40"
                :value="item.id"
              />
            </div>
          </div>
        </div>
      </van-radio-group>
      <div style="text-align: center">
        <van-button
          type="info"
          round
          style="width: 300px"
          @click="submit"
          :color="$abctheme.basecolor"
          >提交</van-button
        >
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      selectLevelId: 0,
      memberlevels: [],
      applyRecord: {},
    };
  },
  created() {
    this.applyRecord = {};
    this.memberlevels = [];
    this.ajax.post("/api/services/app/PhoneUser/QueryMyApplyUpgradeRecord").then((x) => {
      this.applyRecord = x.result;
      if (x.result.id == 0) {
        this.ajax
          .post("/api/services/app/PhoneUser/QueryUpgradeMemberlevels")
          .then((x) => {
            this.memberlevels = x.result;
          });
      }
    });
  },
  methods: {
    submit() {
      if (!this.selectLevelId) {
        this.$toast.fail("请选择您要申请的代理等级");
        return;
      }
      let lev = this.memberlevels.find((x) => x.id == this.selectLevelId);
      this.$dialog
        .confirm({
          title: "提示",
          message: `申请升级通过后登入账号需补缴保证金${lev.earnestMoney}元，充值大货货款${lev.firstRechargeMin}元，是否确定升级? 点击“确认“后，请等待公司审核...`,
        })
        .then(() => {
          this.ajax
            .post("/api/services/app/PhoneUser/ApplyUpgradeLevel", {
              memberLevelId: this.selectLevelId,
            })
            .then(() => {
              this.$toast.success("申请成功");
              location.reload();
            });
        })
        .catch(() => {});
    },
    cancelrecord() {
      this.ajax
        .post("/api/services/app/PhoneUser/CancelApplyUpgrade", {
          id: this.applyRecord.id,
        })
        .then((x) => {
          this.$toast.success("取消成功");
          location.reload();
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.group-main {
  background-color: #fff;
  position: relative;
  padding: 20px;
  margin: 10px;
  box-shadow: 1px 1px 4px #b9b9b9;
  border-radius: 8px;
  font-size: 16px;
  border-radius: 8px;
}

.group-main-conf {
  position: relative;
  padding-left: 80px;
  padding-right: 80px;
}

.group-main-conf-pic {
  position: absolute;
  width: 70px;
  height: 70px;
  left: 0;
  top: 50%;
  transform: translate(0, -50%);
}
.group-main-conf-pic img {
  width: 100%;
  height: 100%;
}
.group-main-conf-radio {
  position: absolute;
  right: 0;
  top: 50%;
  transform: translate(0, -50%);
}
</style>
